<template>
  <div>
    <div class="status" v-html="printStatus()">
    </div>
  </div>
</template>

<script>

export default {
  props: [
    'invoice'
  ],
  data() {
    return {}
  },
  methods: {
    printStatus() {
      let text = '';
      switch (this.invoice.status + '') {
        case '1':
          text = '<span class="badge badge-info">Предварительная</span>';
          break;
        case '2':
          text = '<span class="badge badge-primary">В дороге</span>';
          break;
        case '3':
          text = '<span class="badge badge-warning">Модерация</span>';
          break;
        case '4':
          text = '<span class="badge badge-info">Сборка</span>';
          break;
        case '5':
          text = '<span class="badge badge-info">Резерв</span>';
          break;
        case '0':
          text = '<span class="badge badge-success">Закрыта</span>';
          break;
      }
      return text;
    }
  }
}

</script>

<style>
.status span {
  color: white;
  font-size: 20px;
}
</style>
